import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { Icon, Button } from "../shared";
import { currentLanguage } from "../../util/common";
import { useAppNavigation } from "../../hooks";

const AppointmentTypeModal = ({ show, onCancel, offerId, from }) => {
  const { t } = useTranslation();
  const lang = currentLanguage();
  const [appointmentType, setAppointmentType] = useState("normal");
  const [error, setError] = useState("");
  const { toUrlWithData, localeRoutes } = useAppNavigation();

  const handleSubmit = () => {
    if (!appointmentType) return setError(t("scheduleAppointment.required"));

    const serviceData = {
      service: { id: offerId },
      appointmentType
    };

    if (from === "select-services") {
      toUrlWithData(localeRoutes.appointment[lang], serviceData);
    } else {
      setError("");
      toUrlWithData(localeRoutes.bringIt[lang], {
        ...serviceData,
        offer: true
      });
      onCancel();
    }
  };

  return (
    <Modal size="lg" show={show} onHide={onCancel} centered>
      <Modal.Body className="autohub-modal">
        <div className="close-icon">
          <Icon iconName="xmark" onClick={onCancel} />
        </div>
        <div className="autohub-modal-header">
          <h4>{t("scheduleAppointment.selectAppointmentType")}</h4>
          <p>{t("scheduleAppointment.selectTypeDesc")}</p>
        </div>
        <div className="checkout">
          <div className="pay-form mt-0">
            <div className="card-and-terms">
              <div className="cards">
                <div className="radio-label">
                  <label>
                    <input
                      type="radio"
                      name="payment-option"
                      value="normal"
                      onChange={(e) => setAppointmentType(e.target.value)}
                      checked={appointmentType === "normal"}
                    />
                    <span className="checkmark"></span>
                    {t("scheduleAppointment.normalAppointment")}
                  </label>
                </div>
                <div className="radio-label">
                  <label>
                    <input
                      type="radio"
                      name="payment-option"
                      value="cad"
                      onChange={(e) => setAppointmentType(e.target.value)}
                      checked={appointmentType === "cad"}
                    />
                    <span className="checkmark"></span>
                    {t("scheduleAppointment.cadAppointment")}
                  </label>
                  <span
                    className="radio-input-note"
                    style={{ color: appointmentType === "cad" ? "#05c3de" : "#666" }}>
                    {t("scheduleAppointment.cadChargesNote")}
                  </span>
                </div>
              </div>
              {error && (
                <div className="text-center mt-2">
                  <span className="red-color">{error}</span>
                </div>
              )}
            </div>
          </div>

          <div className="w-100 mt-4 text-center">
            <Button type="blue-roundedRight" customize="m-0" action={handleSubmit}>
              {t("offersDetail.bookAppointment")}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default memo(AppointmentTypeModal);
